/* eslint-disable */
import React, { useEffect } from 'react';
import { ENV } from 'utils/config';
import { paySDKUrl } from 'utils/urlGenerator';

const unloadWidget = (win, instanceName) => {
  // Check if the widget is already loaded
  if (!win[`loaded-${instanceName}`]) {
    console.warn(`Widget with name [${instanceName}] is not loaded.`);
    return;
  }

  // Remove the target widget element if it exists
  const targetElement = win.document.getElementById(`widget-${instanceName}`);
  if (targetElement) {
    targetElement.remove();
    console.log(`Removed widget element [${instanceName}] from the DOM.`);
  }

  // Remove the script tag associated with the widget
  const scriptElement = win.document.getElementById(instanceName);
  if (scriptElement) {
    scriptElement.remove();
    console.log(`Removed script element [${instanceName}] from the DOM.`);
  }

  // Clean up global window properties
  delete win[`loaded-${instanceName}`];
  delete win[instanceName];

  console.log(
    `Unloaded widget instance [${instanceName}] and removed from window object.`
  );
};

const DEFAULT_NAME = '_treezpay';

const PaySDKLoader = ({
  ticketAlphaNumId,
  ticketId,
  totalAmount,
  taxAmount,
  discountTotal,
  ticketItems,
  entityId,
  locationId,
  cashDrawerName,
  authTokenFactory,
  handlePaymentResponse,
  customer,
  employeeReferenceId,
  dispensaryShortName,
  entityName,
  isSelltreezTicket,
  ticketStatus,
  orderType,
}) => {
  const sendPaymentEvent = () => {
    const order = undefined;

    window._treezpay('event', 'payment', {
      handlePaymentResponse: async (response) => {
        handlePaymentResponse(response);
      },
      originalAmount: totalAmount * 1,
      taxes: Math.round(Number(taxAmount) * 100),
      discount: Math.round(Math.abs(Number(discountTotal)) * 100),
      referenceNumber: ticketAlphaNumId,
      employeeReferenceId: employeeReferenceId,
      customer,
      ticketId,
      ticketAlphaNumId,
      entityId,
      entityName,
      locationId, // Optional location ID
      cashDrawerName, // Optional cash drawer name for ST entities
      isSelltreezTicket, // Flag to identify if this is a real SellTreez ticket (6 char alphaNum)
      ticketStatus, // Delivery status (e.g., OUT_FOR_DELIVERY, IN_PROCESS)
      orderType, // Order type (e.g., delivery, pickup)
      order,
    });
  };
  const env = ENV || 'production';

  useEffect(() => {
    // Inject the script
    (function (w, d, s, o, f, js, fjs) {
      w[o] =
        w[o] ||
        function () {
          (w[o].q = w[o].q || []).push(arguments);
        };
      (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
      js.id = o;
      js.src = f;
      js.async = 1;
      js.type = 'text/javascript';
      fjs.parentNode.insertBefore(js, fjs);
    })(window, document, 'script', '_treezpay', paySDKUrl(env));

    // Script initialization
    window._treezpay('init', {
      element: document.querySelector('#paysdk-widget'),
      debug: true,
      authTokenFactory,
      getEntityId: () => {
        return entityId;
      },
      entityId, // Entity ID from input
      locationId, // optional Location ID
      theme: {
        positionFixed: true,
      },
      dispensaryShortName,
      entityName,
      channel: 'virtual_terminal',
      onReady: () => {
        sendPaymentEvent();
      },
    });

    // Cleanup function to remove _treezpay when the component unmounts
    return () => {
      unloadWidget(window, DEFAULT_NAME);
    };
  }, []); // Empty array ensures this effect runs only once when the component mounts

  useEffect(() => {
    if (window._treezpay) {
      sendPaymentEvent();
    }
  }, [totalAmount]);
  return <div id="paysdk-widget" />;
};

export default PaySDKLoader;
